module.exports = __webpack_public_path__ + "static/media/2019-pruefung-alexander.9dd4c1fa.jpg";